import React, { useEffect } from "react";

function Lobby({ voter, newPoll }) {    

    const fetchPoll = (refetch) => {
        fetch(`/api/poll?voter=${voter}`)
        .then(r => r.json())
        .then(r => {
            if (!r.error && r.response !== null) {
                clearInterval(refetch)
                newPoll(r.response)
            }
        })
    }

    useEffect(() => {
        fetchPoll(null)
        let refetch = setInterval(() => {
            fetchPoll(refetch)
        }, 3000)
    }, [])

    return (
        <div>
            <hgroup>
                <h1>Auf Umfrage warten...</h1>
                <h2>Der Ersteller veröffentlich gleich eine Umfrage</h2>
            </hgroup>
            <progress />
        </div>
    )
}

export default Lobby;